import Tooltip from '../../../generic/Tooltip';

const TOOLTIP_TEXT = `Releases are used to distinguish between different versions of the project group.
You can create new releases to modify the collection of projects or track a different arrangement of branches and commits.`;

const ReleaseHelp = () => (
  <Tooltip tooltip={TOOLTIP_TEXT}>
    <span>(?)</span>
  </Tooltip>
);

export default ReleaseHelp;
